module.exports = __webpack_public_path__ + "static/media/instagram-icon.6e1ba4a3.png";